import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { PartnerStaff } from '../redux/types'
import { ApplicationState } from 'AppReducer'
import { deletePartnerStaff } from '../redux/actions'

type StaffOpts = {
  staff: PartnerStaff,
  canRemove?: boolean,
  partnerId: number
}
const Staff: React.FC<StaffOpts> = ({ partnerId, staff, canRemove = true }) => {
  const dispatch = useDispatch()
  const { labels } = useSelector((state: ApplicationState) => state.partnerStaffReducer)

  function handleRemove (): void {
    if (window.confirm('Tem certeza que deseja remover?')) {
      deletePartnerStaff(partnerId, staff.id)(dispatch)
    }
  }

  return (
    <>
      <div className="row staff padding-right-16">
        {
          canRemove &&
          <span
            className="trash-circle-btn button"
            onClick={handleRemove} style={{ position: 'absolute', right: -45 }}
          >
            <i className="fa fa-trash" />
          </span>
        }
        <img
          src={staff.user.person?.picture || `${process.env.PUBLIC_URL}/img/default-user.png`}
          alt="User Profile"
        />
        <div className="grow padding-left-16">
          <div className="row align-start">
            <a className="grow"
              href={`/panel/user/${staff.user.id}`} target="__blank">
              <h2 className="no-margin">{staff.user.person?.name}</h2>
              <p className="no-margin">{staff.user.person?.email || '...'}</p>
            </a>

            <div style={{ width: 230 }} className="role-btn">{labels[staff.role]}</div>

            <div className="row" style={{ width: 290 }}>
              <p className="no-margin">Telefone</p>
              <h2 className="no-margin">{staff.user.person?.phone || '(XX) X XXXX-XXXX'}</h2>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Staff
